// extracted by mini-css-extract-plugin
export default {"input":"checkbox_input__JICHD","checkbox":"checkbox_checkbox__wJC0t","disabled":"checkbox_disabled__HMAGS"};